import { SET_WHITE_LABEL_SETTINGS } from "../actions/whiteLabelSettings";

import { LOG_OUT } from "../actions/user";

const defaultState = {
  isWhiteLabel: false,
  primaryColor: null,
  accentColor: null,
  logoUrl: null,
  appName: null,
  appCode: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_WHITE_LABEL_SETTINGS:
      return Object.assign({}, state, {
        isWhiteLabel: action.settings.isWhiteLabel,
        primaryColor: action.settings.primaryColor,
        accentColor: action.settings.accentColor,
        logoUrl: action.settings.logoUrl,
        appName: action.settings.appName,
        appCode: action.settings.appCode,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/whiteLabelSettings.js